import type { GetHistoricalBestPrices } from "@nwt/norce-pwa/dist/runtime/types/api/product/productParams";

/*
	The market a product's historical prices are asked for.

	Sent with nothing but a part number, the request falls back to the default
	application: an EU product came back priced in SEK at the Swedish VAT rate,
	and `getLowestPriceIncVat` then found no entry at or below the price on the
	page, so the "lowest price in the last 30 days" note silently disappeared on
	every locale except the default one. The locale also keys the server's cache,
	which was otherwise shared by all of them.

	Deliberately without `pricelistSeed`. The prices worth reporting sit on
	campaign lists that have since ended and are no longer in the seed, so
	filtering by it would drop the very records the call is made for. This states
	which market to price for; it is not a filter.
*/
export const historicalBestPricesParams = (
	partNo: string,
	storeContext: {
		cultureCode: string;
		localeCode: string;
		salesAreaId?: number;
	}
): GetHistoricalBestPrices => ({
	partNo,
	cultureCode: storeContext.cultureCode,
	localeCode: storeContext.localeCode,
	...(storeContext.salesAreaId
		? { salesAreaId: String(storeContext.salesAreaId) }
		: {})
});
